import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DashboardComponent, { DashboardButton } from '../../components/DashboardComponent';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import { Checkbox, Paper } from '@material-ui/core';
import { getUTCDateString, addDays, toastError } from '../../utils/Functions';
import { getWeekEndingDate } from '../../utils/TSFunctions';
import { downloadExpenseReportExport } from '../expenses/ExpensesAPI';
import { downloadTimesheetExport } from '../timesheets/TimesheetAPI';
import AppBarContext from '../../contexts/AppBarContext';
import useLoadContext from '../../hooks/useLoadContext';
import DateChanger from '../../components/DateChanger';
import { trackPromise } from 'react-promise-tracker';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  select: {
    width: '100px',
    textAlign: 'left',
    padding: '0 5px',
  },
  optionPicker: {
    margin: 'auto',
    display: 'inline-flex',
    width: '75%',
    padding: theme.spacing(1),
  },
  checkboxWithLabel: {
    margin: 'auto',
    display: 'inline-flex',
  },
}));

export default function AccountingDashboard(props) {
  props.toast.dismiss();
  const classes = useStyles();

  useLoadContext(AppBarContext, { title: 'Accounting Dashboard' });

  const companies = ['SDSMA', 'SDS', 'SDSMAA', 'SDSA', 'TEMP'];
  const [approvedOnly, setApprovedOnly] = useState(true);
  const [unExportedOnly, setUnExportedOnly] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<string>('SDSMA');
  const [weekEnding, setWeekEnding] = useState(getWeekEndingDate(addDays(new Date(), -7)));

  const companyChange = (event) => {
    setSelectedCompany(event.target.value);
  };

  const calendarChange = (value) => {
    setWeekEnding(value);
  };

  const timesheetExport = () => {
    trackPromise(downloadTimesheetExport(selectedCompany, getUTCDateString(weekEnding), approvedOnly, unExportedOnly)).catch((err) => toastError(props.toast, err));
  };

  const expenseExport = () => {
    trackPromise(downloadExpenseReportExport(selectedCompany, getUTCDateString(weekEnding), approvedOnly, unExportedOnly)).catch((err) => toastError(props.toast, err));
  };

  const buttons: DashboardButton[] = [
    {
      onClick: timesheetExport,
      title: 'Timesheets (to CYMA)',
      color: 'blue',
      visible: true,
    },
    {
      onClick: expenseExport,
      title: 'Expenses (to CYMA)',
      color: 'blue',
      visible: true,
    },
  ];

  return (
    <div className='pad'>
      <div className={classes.root}>
        <Paper className={classes.optionPicker}>
          <DateChanger parentDate={weekEnding} onChange={calendarChange} />

          <FormControl className={classes.select}>
            <InputLabel shrink htmlFor='company-label-placeholder'>
              Company
            </InputLabel>
            <Select value={selectedCompany} onChange={companyChange} input={<Input name='company' id='company-label-placeholder' />} displayEmpty name='company'>
              {companies.map((company) => {
                return (
                  <MenuItem key={company} value={company}>
                    <em>{company}</em>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <FormControlLabel
            htmlFor='approved-label-placeholder'
            className={classes.checkboxWithLabel}
            label='Approved Only'
            control={
              <Checkbox
                checked={approvedOnly}
                onChange={(e) => {
                  setApprovedOnly((approvedOnly) => !approvedOnly);
                }}
                value='approvedOnly'
                color='primary'
              />
            }
          />
          <FormControlLabel
            htmlFor='unexported-label-placeholder'
            className={classes.checkboxWithLabel}
            label='Un-Exported Only'
            control={
              <Checkbox
                checked={unExportedOnly}
                onChange={(e) => {
                  setUnExportedOnly((unExportedOnly) => !unExportedOnly);
                }}
                value='unExportedOnly'
                color='primary'
              />
            }
          />
        </Paper>
        <br />
        <DashboardComponent buttons={buttons} toast={props.toast} />
      </div>
    </div>
  );
}
